import React from 'react';
import PrayerTimes from './components/PrayerTimes';
import './App.css';

function App() {
  return (
    <div className="App">
      <PrayerTimes />
    </div>
  );
}

export default App;
